<template>
  <div>
    <Filters :query="this.$route.query" @submit="filter" @reset="resetFilters"/>
    <Loader v-if="loading" />
    <section v-else class="dashboard__data">
      <div class="container-fluid pb-24">
        <div v-if="applications.length">
          <div class="dashboard__list" :class="{'show': $store.getters.isDisplayList}">
            <div class="dashboard__table__row dashboard__table__header">
              <div class="dashboard__table__column" style="width: 8.5%;">
                {{ $lang.app.NUMBER }}
              </div>
              <div class="dashboard__table__column" style="width: 31%;">
                {{ $lang.app.DENOMINATION }}
              </div>
              <div class="dashboard__table__column" style="width: 23%;">
                {{ $lang.app.ADDRESS }}
              </div>
              <div class="dashboard__table__column" style="width: 8.5%;">
                {{ $lang.app.REGISTRATION_DATE }}
              </div>
              <div class="dashboard__table__column" style="width: 8.5%;">
                {{ $lang.app.CURATOR }}
              </div>
              <div class="dashboard__table__column" style="width: 20.5%;">
                {{ $lang.app.STATUS }}
              </div>
            </div>
            <router-link v-for="(application, index) in applications" :key="index"
                         :to="{
                        name: $store.getters.isRegistrator ? 'EmployeeApplicationMain' : $store.getters.isRegistrator ? 'EmployeeApplicationMain' : 'EmployeeApplicationResolutions',
                        params: { applicationId: application.id }
                        }"
                         class="dashboard__table__row">
              <div class="dashboard__table__column" style="width: 8.5%;">
                <div v-if="application.docNumber"
                     class="dashboard__table__number">{{ application.docNumber }}</div>
              </div>
              <div class="dashboard__table__column break-words" style="width: 31%;">
                {{ application.name }}
              </div>
              <div class="dashboard__table__column" style="width: 23%;">
                <div class="dashboard__table__address">{{ getAddress(application.address) }}</div>
              </div>
              <div class="dashboard__table__column" style="width: 8.5%;">
                {{ application.registerDate ? $moment(application.registerDate).format('DD.MM.yyyy') : '-' }}
              </div>
              <div class="dashboard__table__column" style="width: 8.5%;">
                {{ application.curator?.fullNameInitials }}
              </div>
              <div class="dashboard__table__column d-flex" style="width: 20.5%;">
                <div class="dashboard__table__status green__lighter">{{ $lang.$translate({ru: application.status.nameRu, kg: application.status.nameKg }) }}</div>
                <div v-if="application.finishDate === null && $moment(currentDate).isSameOrAfter(application.deadline)"
                     class="dashboard__table__deadline red__lighter">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__info"></use>
                  </svg>
                  <div class="status__popover right">
                    <span class="status__popover__title">Срок: <strong>{{application.deadline ? $moment(application.deadline).format('DD.MM.yyyy') : ''}}</strong></span>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="dashboard__grid" :class="{'show': $store.getters.isDisplayGrid}">
            <div class="row">
              <div v-for="(application, index) in applications" :key="index"
                   class="col-xxl-3 col-xl-4 col-lg-4">
                <router-link :to="{
                            name: $store.getters.isRegistrator ? 'EmployeeApplicationMain' : 'EmployeeApplicationResolutions',
                            params: { applicationId: application.id }
                          }"
                             class="dashboard__application__item">
              <span class="dashboard__application__header">
                <span v-if="application.docNumber" class="dashboard__application__number">{{ application.docNumber }}</span>
                <span class="dashboard__application__status green__lighter">{{ $lang.$translate({ru: application.status.nameRu, kg: application.status.nameKg }) }}</span>
                <span v-if="application.finishDate === null && $moment(currentDate).isSameOrAfter(application.deadline)"
                      class="ml-2 dashboard__application__status">
                    срок: {{application.deadline ? $moment(application.deadline).format('DD.MM.yyyy') : ''}}
                </span>
              </span>
                  <h3 class="dashboard__application__title break-words">{{ application.name }}</h3>
                  <p class="dashboard__application__address">{{ getAddress(application.address) }}</p>
                  <span class="dashboard__application__dates">
                <span class="row">
                  <span class="col-lg-6">
                    <span class="stack__list">
                      <span class="stack__label">{{ $lang.app.CURATOR }}</span>
                      <span class="stack__value">{{ application.curator?.fullNameInitials }}</span>
                    </span>
                  </span>
                  <span class="col-lg-6">
                    <span class="stack__list">
                      <span class="stack__label">{{ $lang.app.REGISTRATION_DATE }}</span>
                      <span class="stack__value">{{ application.registerDate ? $moment(application.registerDate).format('DD.MM.yyyy') : '-' }}</span>
                    </span>
                  </span>
                </span>
              </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="flex items-center justify-center h-20 bg-white">
          <h4 class="text-xl">
            {{ $lang.app.APPLICATIONS_LIST_EMPTY }}
          </h4>
        </div>
        <Pagination
            v-if="applications.length"
            :value="pagination.page"
            @change="changePage"
            :limit="pagination.limit"
            :total-records="pagination.totalRecords"
        />
      </div>
    </section>
  </div>
</template>
<script>
import Filters from "../../../components/employee/application/Filters"
// import Sort from "../../../components/employee/application/Sort"
import applicationApi from "../../../api/employee/application"
import Pagination from "../../../components/Pagination"
import PaginationMixin from "../../../mixins/paginationMixin"
import {getValueByKey as applicationTypesGetValueByKey} from "../../../helpers/constants/applicationTypes";

export default {
  components: {
    Filters,
    // Sort,
    Pagination,
  },
  mixins: [PaginationMixin],
  data() {
    return {
      loading: false,
      applications: [],
      deleteId: null,
      currentDate: null
    };
  },
  created() {
    this.setupPage();
    this.fetchResources();
    this.currentDate = new Date();
  },
  watch: {
    '$route.query'() {
      this.setupPage()
      this.fetchResources()
    }
  },
  methods: {
    applicationTypesGetValueByKey,
    changePage(value) {
      this.$router.push({
        name: 'EmployeeApplicationsList',
        query: { ...this.$route.query, page: value }
      })
    },
    fetchResources() {
      this.loading = true;
      applicationApi
        .getApplications({
          ...this.$route.query,
          type: this.applicationTypesGetValueByKey('SYSTEM'),
          limit: this.pagination.limit,
          page: this.pagination.page,
        })
        .then((data) => {
          this.applications = data.list;
          this.pagination.totalRecords = data.totalRecords;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAddress(address) {
      if(address) {
        let text = address.addressTxt
        if(address.streetTxt) text = text + ', ' + address.streetTxt
        if(address.houseTxt) text = text + ', ' + address.houseTxt
        if(address.flatTxt) text = text + ', ' + address.flatTxt
        if(address.uchnum) text = text + ', ' + this.$lang.app.PLOT + ': ' + address.uchnum

        return text
      }
      return '-'
    },
    filter(data) {
      this.$router.push({
        name: "EmployeeApplicationsList",
        query: {
          ...this.$route.query,
          ...data,
        }
      })
    },
    resetFilters() {
      this.$router.push({
        name: "EmployeeApplicationsList",
      })
    }
  },
};
</script>
